import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      background: "white",
      borderRadius: 6,
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      "& .MuiTextField-root .MuiOutlinedInput-input": {
        padding: "10.5px 16px"
      }
    },
    tabs: {
      display: "grid",
      gridTemplateColumns: "auto auto"
    },
    tabItem: {
      padding: "1.2rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#E0E0E0",
      cursor: "pointer",
      "&.active": {
        transition: "all 0.3s",
        background:
          "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)"
      }
    },
    searchBox: {
      padding: "2.4rem 1.6rem 1.6rem"
    },
    searchInput: {
      display: "flex"
    },
    button: {
      height: "4rem",
      minWidth: "auto",
      backgroundColor: theme.palette.grey[900],
      "&:active": {
        background: theme.palette.grey[700],
        outline: "none",
        border: `${theme.palette.grey[900]} solid 3px`,
        borderRadius: "4px",
        transition: "0s"
      },
      "&:hover": {
        backgroundColor: theme.palette.grey[700]
      }
    },
    formControl: {
      display: "grid",
      gridTemplateColumns: "auto 48px",
      gridGap: "1rem",
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 11px) scale(1)",
        "&.MuiInputLabel-shrink": {
          transform: "translate(12px, 7px) scale(0.75)"
        }
      }
    },
    errorMessage: {
      color: theme.palette.error.light,
      lineHeight: "18px"
    },
    successMessage: {
      color: theme.palette.success.main
    },
    cannotClick: {
      border: `1px solid ${theme.palette.background.default}`,
      background: theme.palette.background.default,
      pointerEvents: "none",
      "& fieldset": {
        borderColor: theme.palette.background.default
      },
      "& input": {
        color: theme.palette.grey[900]
      }
    },
    info: {
      marginTop: "2rem",
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: "0.7rem"
      }
    }
  }),
  { name: "SearchBar" }
);
export default useStyles;
